<template>
  <div class="box">
    <el-card class="box-card">
      <div slot="header">
        <h3>{{ title }}</h3>
      </div>
      <el-card>
        <h4>基本信息</h4>
        <el-form :model="basicInfo" label-width="200px" ref="basicForm">
          <el-form-item
            label="名称"
            prop="name"
            :rules="[{ required: true, message: '请输入', trigger: 'blur' }]"
          >
            <el-input v-model="basicInfo.name" autocomplete="off" style="width: 50%"></el-input>
          </el-form-item>
          <el-form-item label="流程key" prop="keys">
            <el-select
              v-model="basicInfo.keys"
              placeholder="请选择"
              style="width: 50%"
              multiple
              disabled
            >
              <el-option
                v-for="obj in processKeyList"
                :key="obj.id"
                :label="obj.label"
                :value="obj.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="event_key"
            prop="event_key"
            :rules="[{ required: true, message: '请输入', trigger: 'change' }]"
            class="form-item"
          >
            <el-input
              v-model="basicInfo.event_key"
              class="form-input"
              placeholder="请输入"
              :disabled="id"
            ></el-input>
            <el-tooltip effect="dark" placement="top-start">
              <i class="el-icon-question" style="margin-left: 10px" />
              <div style="width: 200px" slot="content">
                该字段仅应用于版本管理中的发版同步功能，为发版同步功能中标识通知消息事件的唯一性
              </div>
            </el-tooltip>
          </el-form-item>

          <el-form-item label="备注" prop="remark">
            <el-input
              type="textarea"
              :rows="2"
              v-model="basicInfo.remark"
              maxlength="50"
              show-word-limit
              autocomplete="off"
              style="width: 50%"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-card>
      <div>
        <el-card style="width: 100%; margin-top: 20px">
          <h4>通知模版</h4>
          <el-form
            :model="templateInfo"
            :rules="templateInfoFormRule"
            label-width="200px"
            ref="templateForm"
          >
            <el-form-item label="类型" prop="subref">
              <el-select
                v-model="templateInfo.subref"
                placeholder="请选择"
                style="width: 50%"
                @change="onSubrefChange"
              >
                <el-option
                  v-for="obj in noticeTemplateTypes"
                  :key="obj.label"
                  :label="obj.label"
                  :value="obj.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="templateInfo.subref === 'lclmsg'"
              prop="system_type"
              label="站内信类型"
            >
              <el-select
                style="width: 50%"
                filterable
                v-model="templateInfo.system_type"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in systemMessageTypeList"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              label="企微消息类型"
              prop="wxmsg_type"
              v-if="templateInfo.subref === 'wxmsg'"
            >
              <el-radio-group v-model="templateInfo.wxmsg_type">
                <el-radio :label="1">文本消息</el-radio>
                <el-radio :label="2">小程序通知消息</el-radio>
                <el-radio :label="3">按钮交互型消息</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-divider></el-divider>
            <h4>
              接收人设置
              <span style="color: #f56c6c; margin-left: 5px">*至少选填一项</span>
            </h4>
            <el-form-item label="指定接收人变量" prop="to2">
              <el-select v-model="templateInfo.to2" placeholder="请选择" style="width: 50%">
                <el-option
                  v-for="obj in recipientVariable"
                  :key="obj.label"
                  :label="obj.label"
                  :value="obj.value"
                ></el-option>
              </el-select>
              <el-input
                v-if="templateInfo.to2 === 'specify_variable'"
                v-model="templateInfo.variable"
                placeholder="请输入指定变量"
                style="width: 314px; margin-left: 4px"
              ></el-input>
              <el-tooltip effect="dark" placement="top-start">
                <i class="el-icon-question" style="margin-left: 10px" />
                <div style="width: 200px" slot="content">
                  该选择框仅用于在审批流中配置审批人节点触发通知消息时的接收人设置指定接收人变量
                </div>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="指定其他接收人" prop="to">
              <el-select
                v-model="templateInfo.to"
                multiple
                filterable
                remote
                placeholder="请选择"
                :remote-method="getCandidateUserList"
                style="width: 50%"
                collapse-tags
              >
                <el-option
                  v-for="(item, index) in candidateUserList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-divider></el-divider>
            <el-form-item label="通知标题" prop="title">
              <el-input
                class="notice-title"
                v-model="templateInfo.title"
                autocomplete="off"
                style="width: 50%"
              ></el-input>
              <el-button
                @click="openMetaDiagLog('title')"
                style="margin-left: 10px"
                :disabled="basicInfo.keys.length !== 1"
              >
                插入对象字段
              </el-button>
            </el-form-item>
            <el-form-item v-if="needPlatform" prop="platform" label="通知终端">
              <el-checkbox-group v-model="templateInfo.platform">
                <el-checkbox :label="1">小程序端</el-checkbox>
                <el-checkbox :label="2">web端</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="通知内容" prop="content">
              <template v-if="templateInfo.subref === 'wxmsg'">
                <div style="display: flex">
                  <el-input
                    type="textarea"
                    :rows="2"
                    v-model="templateInfo.content"
                    autocomplete="off"
                    style="width: 50%"
                    placeholder="请输入"
                    class="notice-content"
                    v-show="templateInfo.wxmsg_type !== 2"
                  ></el-input>
                  <InputJson
                    v-model="templateInfo.content"
                    v-show="templateInfo.wxmsg_type === 2"
                    class="form-input"
                  />
                  <el-button
                    @click="openMetaDiagLog('content')"
                    style="margin-left: 10px; height: 40px"
                    :disabled="basicInfo.keys.length !== 1"
                  >
                    插入对象字段
                  </el-button>
                </div>
                <a
                  style="color: #0077ff"
                  :href="documentLink"
                  target="_blank"
                  v-if="templateInfo.wxmsg_type === 2"
                >
                  点击查看JSON格式相关文档，仅需填写miniprogram_notice属性下的对象
                </a>
              </template>
              <template v-if="templateInfo.subref !== 'wxmsg'">
                <div v-if="templateInfo.subref === 'email'">
                  <el-radio-group v-model="templateInfo.editor_type" @change="emailMsgTypeChange">
                    <el-radio :label="1">编辑富文本</el-radio>
                    <el-radio :label="2">编辑HTML</el-radio>
                  </el-radio-group>
                </div>
                <template v-if="templateInfo.editor_type !== 2">
                  <el-button
                    @click="openMetaDiagLog('content')"
                    style="margin-left: 0; color: #0069fa"
                    :disabled="basicInfo.keys.length !== 1"
                    type="info"
                  >
                    插入对象字段
                  </el-button>
                  <RichEditor
                    :content="templateInfo.content"
                    @getContent="
                      (e) => {
                        templateInfo.content = e;
                        $refs.templateForm.validateField('content');
                      }
                    "
                  />
                </template>
                <!-- html消息 -->
                <template v-else-if="templateInfo.editor_type === 2">
                  <div class="editor-block">
                    <div class="editor-part">
                      <div class="editor-title">
                        编辑HTML
                        <el-button
                          style="margin-left: 0; color: #0069fa"
                          :disabled="basicInfo.keys.length !== 1"
                          type="info"
                          @click="openMetaDiagLog('content')"
                        >
                          插入对象字段
                        </el-button>
                      </div>
                      <CodeEditor
                        class="code-editor"
                        v-model="templateInfo.content"
                        :options="htmlOptions"
                      />
                      <el-button type="text" @click="openPreview">预览</el-button>
                    </div>
                    <div class="editor-part">
                      <div class="editor-title">自定义脚本</div>
                      <CodeEditor
                        class="code-editor"
                        v-model="templateInfo.script"
                        :options="jsOptions"
                      />
                      <el-button type="text" @click="openHelp">帮助文档</el-button>
                    </div>
                  </div>
                </template>
              </template>
            </el-form-item>

            <!-- 按钮交互型表单 -->
            <template v-if="templateInfo.wxmsg_type === 3">
              <h4 style="position: relative">
                按钮交互型消息
                <div style="position: absolute; right: calc(50% - 540px); top: -20px">
                  <h4>配置项参照</h4>
                  <img
                    src="https://cdn.nges.tencent.com/nges_1/20105202/d7d80544-9aaa-465f-93bf-c2d383ff95a1.png"
                    alt=""
                  />
                </div>
              </h4>

              <el-form-item prop="source_switch" label="source">
                <el-switch v-model="templateInfo.source_switch"></el-switch>
              </el-form-item>
              <template v-if="templateInfo.source_switch">
                <el-form-item prop="source.icon_url" label="source.icon_url">
                  <uploadImg
                    ref="logo"
                    tip="文件尺寸建议72*72px"
                    :file="templateInfo.source.icon_url"
                    @change="handleFileChange"
                    :config="{
                      top: '41px',
                      left: '91px',
                      logoWidth: '90px',
                      logoHeight: 'auto',
                      bgcHeight: '360px',
                      bgcImgUrl:
                        'https://baike-med-1256891581.file.myqcloud.com/2022122/810c3900-7a8e-11ed-89ce-4ff3ab5f0cf9_0.jpg',
                    }"
                  />
                </el-form-item>
                <el-form-item prop="source.desc" label="source.desc">
                  <el-input
                    v-model="templateInfo.source.desc"
                    placeholder="不超过20个字"
                    autocomplete="off"
                    style="width: 50%"
                    maxlength="20"
                  ></el-input>
                </el-form-item>
              </template>

              <el-form-item prop="main_title.title" label="main_title.title">
                <el-input
                  v-model="templateInfo.main_title.title"
                  placeholder="不超过36个字"
                  autocomplete="off"
                  style="width: 50%"
                  maxlength="36"
                ></el-input>
              </el-form-item>
              <el-form-item prop="main_title.desc" label="main_title.desc">
                <el-input
                  v-model="templateInfo.main_title.desc"
                  placeholder="不超过44个字"
                  autocomplete="off"
                  style="width: 50%"
                  maxlength="44"
                ></el-input>
              </el-form-item>

              <el-form-item prop="horizontal_content_list_switch" label="horizontal_content_list">
                <el-switch v-model="templateInfo.horizontal_content_list_switch"></el-switch>
                <div style="color: #9babbc; font-size: 12px">
                  二级标题最多5个字，文本内容最多2行（最多15×2个字）
                </div>
              </el-form-item>
              <template v-if="templateInfo.horizontal_content_list_switch">
                <el-form-item prop="horizontal_content_list" label="horizontal_content">
                  <div style="display: flex; justify-content: space-around; width: 50%">
                    <div style="text-align: left; width: 100%">horizontal_content_list.keyname</div>
                    <div style="text-align: left; width: 100%">horizontal_content_list.value</div>
                  </div>
                  <div v-for="(item, index) in horizontalContentList" :key="index">
                    <div
                      style="
                        display: flex;
                        justify-content: space-around;
                        width: 50%;
                        margin-bottom: 12px;
                      "
                    >
                      <el-form-item
                        :prop="generateProp('horizontal_content_list', index, 'keyname')"
                        style="flex: 1"
                      >
                        <el-input
                          placeholder="不超过5个字"
                          autocomplete="off"
                          v-model="item.keyname"
                          @input="handleKeynameChange(item, index)"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        :prop="generateProp('horizontal_content_list', index, 'value')"
                        style="flex: 1"
                      >
                        <el-input
                          placeholder="不超过15x2个字"
                          autocomplete="off"
                          style="margin-left: 12px"
                          v-model="item.value"
                          @input="handleValueChange(item, index)"
                        ></el-input>
                      </el-form-item>

                      <i class="el-icon-delete del" @click="del_horizontal_content(index)"></i>
                    </div>
                  </div>
                  <el-button
                    v-if="canAddMoreContent"
                    style="margin-top: 8px"
                    @click="add_horizontal_content"
                  >
                    + 添加选项
                  </el-button>
                </el-form-item>
              </template>

              <el-form-item prop="card_action_switch" label="card_action">
                <el-switch v-model="templateInfo.card_action_switch"></el-switch>
              </el-form-item>
              <template v-if="templateInfo.card_action_switch">
                <el-form-item prop="card_action.type" label="card_action.type">
                  <el-radio-group v-model="templateInfo.card_action.type">
                    <el-radio :label="0">0</el-radio>
                    <el-radio :label="1">1</el-radio>
                    <el-radio :label="2">2</el-radio>
                  </el-radio-group>
                  <div style="color: #9babbc; font-size: 12px">
                    0代表不是链接，1 代表跳转url，2 代表打开小程序
                  </div>
                </el-form-item>
                <el-form-item
                  v-if="templateInfo.card_action.type === 1"
                  prop="card_action.url"
                  label="card_action.url"
                >
                  <el-input
                    v-model="templateInfo.card_action.url"
                    placeholder="请输入"
                    autocomplete="off"
                    style="width: 50%"
                  ></el-input>
                </el-form-item>

                <template v-if="[0, 2].includes(templateInfo.card_action.type)">
                  <!-- <el-form-item prop="card_action.appid" label="card_action.appid">
                    <el-input
                      v-model="templateInfo.card_action.appid"
                      placeholder="请输入"
                      autocomplete="off"
                      style="width: 50%"
                    ></el-input>
                  </el-form-item> -->
                  <el-form-item prop="card_action.pagepath" label="card_action.pagepath">
                    <el-input
                      v-model="templateInfo.card_action.pagepath"
                      placeholder="请输入"
                      autocomplete="off"
                      style="width: 50%"
                    ></el-input>
                  </el-form-item>
                </template>
              </template>

              <template>
                <el-form-item prop="button_list" label="button" class="button_list_item">
                  <el-popover width="256" trigger="click">
                    button_list.style
                    <div style="display: flex; flex-wrap: wrap; gap: 8px">
                      <el-button style="margin-left: 0" type="primary">按钮样式1</el-button>
                      <el-button style="margin-left: 0" type="primary" plain>按钮样式2</el-button>
                      <el-button style="margin-left: 0" type="danger" plain>按钮样式3</el-button>
                      <el-button style="margin-left: 0" type="info" plain>按钮样式4</el-button>
                    </div>
                    <i
                      slot="reference"
                      class="iconfont icon-question"
                      style="position: absolute; top: 13px; left: -24px"
                    />
                  </el-popover>

                  <div style="display: flex; justify-content: space-around; width: 50%">
                    <div style="text-align: left; width: 100%">button_list.text</div>
                    <div style="text-align: left; width: 100%">button_list.style</div>
                    <div style="text-align: left; width: 100%">button_list.key</div>
                  </div>
                  <div v-for="(item, index) in button_list" :key="index">
                    <div
                      style="
                        display: flex;
                        justify-content: space-around;
                        width: 50%;
                        margin-bottom: 12px;
                      "
                    >
                      <el-form-item
                        :prop="generateProp('button_list', index, 'text')"
                        style="flex: 1"
                      >
                        <el-input
                          placeholder="不超过10个字"
                          autocomplete="off"
                          v-model="item.text"
                          maxlength="10"
                        ></el-input>
                      </el-form-item>
                      <el-select
                        v-model="item.style"
                        placeholder="请选择"
                        style="flex: 1; margin-left: 12px"
                      >
                        <el-option
                          v-for="obj in [1, 2, 3, 4]"
                          :key="obj"
                          :label="obj"
                          :value="obj"
                        ></el-option>
                      </el-select>
                      <el-select
                        v-model="item.key"
                        placeholder="请选择"
                        style="flex: 1; margin-left: 12px"
                      >
                        <el-option
                          v-for="obj in ['approval', 'reject', 'rollback']"
                          :key="obj"
                          :label="obj"
                          :value="obj"
                        ></el-option>
                      </el-select>
                      <i class="el-icon-delete del" @click="del_button(index)"></i>
                    </div>
                  </div>
                  <el-button v-if="canAddButton" style="margin-top: 8px" @click="add_button">
                    + 添加选项
                  </el-button>
                </el-form-item>
              </template>
              <el-form-item prop="button_list_switch" label="button_list">
                <el-input
                  style="width: 50%"
                  placeholder="不超过5个字"
                  disabled
                  v-model="button_list.length"
                ></el-input>
              </el-form-item>
              <el-form-item prop="replace_text" label="replace_text">
                <el-input
                  style="width: 50%"
                  placeholder="请输入"
                  v-model="templateInfo.replace_text"
                ></el-input>
              </el-form-item>
            </template>

            <!-- 按钮交互型表单 -->
          </el-form>
        </el-card>
      </div>
      <div class="button-group">
        <el-button type="info" @click="goBack">返回</el-button>
        <el-button
          v-if="jurisdiction.eventManage_workflow_editNoticeEvent"
          type="primary"
          @click="submitNoitceDetail"
        >
          提交
        </el-button>
      </div>
    </el-card>
    <select-meta-dialog-vue ref="metaDialog" :object-names="objectNames" @insertion="insertion" />
    <Clipboard ref="copy" :copytext="copytext" />

    <!-- messageBox -->
    <MessageBox ref="previewBox" class="preview-box">
      <template v-slot:content>
        <div v-html="previewContent" />
      </template>
    </MessageBox>
    <MessageBox ref="helpBox">
      <template v-slot:content>
        <div>脚本语法使用js语法（部分支持）和 underscore(_)，注意变量名不要以双下划线开头</div>
        <div>1. 脚本中引用自定义变量，使用 args.xxx，如 args.task_id</div>
        <div>
          2. 脚本中引用元数据变量，使用 {object}.xxx，如
          events_meeting.meeting_name，注意元数据变量仅支持引用HTML模版中使用的字段，其余为undefined
        </div>
        <div>
          3. 模版中可以引用脚本中定义的变量，如 {% foo %}，可以在此处使用表达式计算值，如 {% foo + 1
          %}
        </div>
        <div>当前支持的IO方法：</div>
        <div>- debug_log([any],...) 打印日志，参数：任意类型，返回：无</div>
        <div>
          - get_query([query]) 获取query结果，参数：query字符串，返回：元数据query接口返回data参数
        </div>
        <div>
          - get_field_option([object],[field])
          获取枚举字段的选项，参数：任意对象名、字段名，返回：value到label的映射
        </div>
      </template>
    </MessageBox>
  </div>
</template>

<script>
import { noticeTemplateTypes, candidateUserAtributes } from '../common';
import { throttle } from '@/utils/util';
import selectMetaDialogVue from './select-meta-dialog.vue';
import InputJson from '@/components/inputJson';
import Clipboard from 'nges-common/src/web/components/Clipboard';
import CodeEditor from '../../notice/noticeDetail/editor.vue';
import MessageBox from '@/components/messageBox';
import RichEditor from '@/components/richEditor';
import { difference } from 'lodash';
import uploadImg from '@/components/uploadImg';
import { mapGetters } from 'vuex';

const _ = { difference };
export default {
  components: {
    selectMetaDialogVue,
    RichEditor,
    InputJson,
    Clipboard,
    CodeEditor,
    MessageBox,
    uploadImg,
  },
  data() {
    return {
      id: '',
      userId: '',
      title: '通知消息事件详情',
      basicInfo: {
        name: '',
        keys: [],
        event_key: '',
        remark: '',
      },
      templateInfo: {
        title: '',
        content: '',
        to: [],
        to2: '',
        variable: '',
        subref: '',
        system_type: '',
        wxmsg_type: 1,
        platform: [1, 2],
        editor_type: 1,
        script: '',

        // 按钮交互型字段
        source_switch: false,
        source: {
          icon_url: [],
          desc: '',
        },

        main_title: {
          title: '',
          desc: '',
        },

        horizontal_content_list_switch: false,
        horizontal_content_list: [{ keyname: '', value: '' }],

        card_action_switch: false,
        card_action: {
          type: '',
          url: '',
          // appid: '',
          pagepath: '',
        },

        button_list_switch: false,
        button_list: [
          { text: '同意', style: 1, key: 'approval' },
          { text: '拒绝', style: 3, key: 'reject' },
        ],

        replace_text: '',
      },
      processKeyList: [],
      candidateUserList: [],
      noticeTemplateTypes,
      candidateUserAtributes,
      insertType: '',
      objectNames: [],
      // 记录列表页状态
      statusTab: '',
      eventTypes: '',
      // 自动复制变量
      copytext: '',
      documentLink:
        'https://developer.work.weixin.qq.com/document/path/90236#%E5%B0%8F%E7%A8%8B%E5%BA%8F%E9%80%9A%E7%9F%A5%E6%B6%88%E6%81%AF',
      systemMessageTypeList: [],
      // 代码输入框配置
      htmlOptions: {
        placeholder: '<html></html>',
        autorefresh: true,
        mode: 'text/html',
        matchBrackets: true,
        tabSize: 4,
        lineNumbers: true,
        lineWrapping: true,
      },
      jsOptions: {
        placeholder: 'var a = 1',
        autorefresh: true,
        mode: 'text/javascript',
        matchBrackets: true,
        tabSize: 4,
        lineNumbers: true,
        lineWrapping: true,
      },
      // 校验规则
      templateInfoFormRule: {
        subref: [{ required: true, message: '请选择', trigger: 'blur' }],
        system_type: [{ required: true, message: '请选择', trigger: 'blur' }],
        wxmsg_type: [{ required: true, message: '请选择', trigger: 'blur' }],
        title: [{ required: true, message: '请输入通知标题', trigger: 'blur' }],
        content: [
          { required: true, message: '请输入通知内容' },
          {
            validator: (rule, value, callback) => {
              const err = this.validateContent();
              if (err) {
                callback(err);
              } else {
                callback();
              }
            },
          },
        ],
        platform: [{ required: true, message: '请选择通知终端 ', trigger: 'change' }],
        'main_title.title': [{ required: true, message: '请输入', trigger: 'blur' }],
        'card_action.url': [{ required: true, message: '请输入', trigger: 'blur' }],
        'horizontal_content_list[0].keyname': [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        'button_list[0].text': [{ required: true, message: '请输入', trigger: 'blur' }],
      },
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']), // user 模块名称
    jurisdiction() {
      const jurisdictionArray = ['eventManage_workflow_editNoticeEvent'];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }

      return jurisdictionObj;
    },
    recipientVariable() {
      return this.templateInfo.wxmsg_type === 3
        ? this.candidateUserAtributes.filter((i) => i.value === 'current_assignee')
        : this.candidateUserAtributes;
    },
    generateTo2() {
      if (!this.templateInfo.to2) {
        return [];
      }
      return this.templateInfo.to2 === 'specify_variable'
        ? [this.templateInfo.variable]
        : [this.templateInfo.to2];
    },
    generateToType() {
      if (!this.templateInfo.to2) {
        return 0;
      }
      return this.templateInfo.to2 === 'specify_variable' ? 2 : 1;
    },
    previewContent() {
      return this.templateInfo.content.replaceAll('href="mailto', '');
    },
    // 只选了站内信的时候,需要选择终端
    needPlatform() {
      return this.templateInfo.subref === 'lclmsg';
    },
    horizontalContentList() {
      return this.templateInfo.horizontal_content_list;
    },
    canAddMoreContent() {
      return this.horizontalContentList?.length < 6;
    },
    canAddButton() {
      return this.button_list?.length < 6;
    },
    button_list() {
      return this.templateInfo.button_list || [];
    },
  },
  watch: {
    horizontalContentList(horizontalContentList) {
      if (horizontalContentList?.length) {
        horizontalContentList.forEach((item, index) => {
          this.templateInfoFormRule[`horizontal_content_list[${index}].keyname`] = [
            { required: true, message: '请输入', trigger: 'blur' },
          ];
        });
      }
    },
    button_list(button_list) {
      if (button_list?.length) {
        button_list.forEach((item, index) => {
          this.templateInfoFormRule[`button_list[${index}].text`] = [
            { required: true, message: '请输入', trigger: 'blur' },
          ];
        });
      }
    },
  },
  created() {
    const { id, statusTab, eventTypes } = this.$route.query;
    this.id = id;
    this.statusTab = statusTab;
    this.eventTypes = eventTypes;
    this.getSystemMessageTypes();
    if (id) {
      this.getProcessActionDetail(id);
    }
  },
  methods: {
    onSubrefChange(e) {
      if (e !== 'wxmsg') {
        this.$nextTick(() => {
          this.$refs.quillEditor.initHtml(this.templateInfo.content);
        });
      }
    },
    getCandidateUserList(name = '', delay = 300) {
      if (!name) {
        this.candidateUserList = this.templateInfo?.to?.map((value) => {
          return {
            value,
            label: value.replace(/\((.+?)\)/g, ''),
          };
        });
        return;
      }
      throttle(() => {
        this.$request({
          url: this.$api.getUserList,
          data: {
            page_size: 100,
            page: 1,
            keyword: name,
          },
          showLoading: false,
          cb: ({ data }) => {
            if (data) {
              const map = {};
              this.candidateUserList = [
                ...(this.templateInfo.to || []).map((value) => ({
                  value,
                  label: value.replace(/\((.+?)\)/g, ''),
                })),
                ...data.map((item) => ({
                  label: `${item.name}${item.description ? `-${item.description}` : ''}`,
                  value: `(${item.account})${item.name}${
                    item.description ? `-${item.description}` : ''
                  }`,
                })),
              ].reduce((prev, cur) => {
                map[cur.value] ? '' : (map[cur.value] = true && prev.push(cur));
                return prev;
              }, []);
            } else {
              this.candidateUserList = [];
            }
          },
        });
      }, delay).call(this);
    },
    getProcessActionDetail(id) {
      this.$request({
        url: this.$api.getProcessActionById,
        data: { id },
        cb: ({ process }) => {
          if (process) {
            const { name, remark, keys, template, event_key } = process;
            this.basicInfo = {
              name,
              remark,
              keys,
              event_key,
            };

            let generateTo2 = '';
            let generateVariable = '';

            const { to2 } = template.notify;
            if (!to2?.length) {
              generateTo2 = '';
            } else {
              generateTo2 = to2[0];
            }
            // 非有调用方指定变量
            if (
              generateTo2 &&
              !['current_assignee', 'last_assignee', 'starter'].includes(generateTo2)
            ) {
              generateTo2 = 'specify_variable';
              generateVariable = to2[0];
            }

            const { template_card = {} } = JSON.parse(template.notify.btn_msg_body || null) || {};
            const { source, horizontal_content_list, card_action } = template_card;
            this.templateInfo = {
              ...this.templateInfo,
              ...template.notify,
              to2: generateTo2,
              variable: generateVariable,
              ...template_card,
              source_switch: !!source,
              source: {
                desc: source?.desc || '',
                icon_url: source?.icon_url?.length ? [{ url: source.icon_url }] : [],
              },
              horizontal_content_list_switch: !!horizontal_content_list,
              card_action_switch: !!card_action,
            };
            if (this.templateInfo.subref !== 'wxmsg') {
              this.$refs.quillEditor.initHtml(this.templateInfo.content);
            }
            this.getCandidateUserList('', 0);
            if (keys.length) {
              const key1 = keys[0];
              this.$request({
                url: this.$api.metaGetObjectByRelatedWorkflow,
                data: {
                  process_def_key: key1,
                },
                cb: ({ list }) => {
                  this.objectNames = list.map((i) => i.name);
                },
              });
            }
          }
        },
      });
    },
    generateProp(parent, index, cur) {
      return `${parent}[${index}].${cur}`;
    },
    handleFileChange(val) {
      console.log(val, 'fdsfjsdlfjsdljfdsjlfjdslfjdsj');
      this.templateInfo.source.icon_url = val;
    },
    add_horizontal_content() {
      this.templateInfo.horizontal_content_list.push({ keyname: '', value: '' });
    },
    del_horizontal_content(index) {
      this.templateInfo.horizontal_content_list.splice(index, 1);
    },
    handleKeynameChange(item, index) {
      console.log(item, index);
      // this.templateInfo.horizontal_content_list[index].keyname = value;
    },
    handleValueChange(item, index) {
      console.log(item, index);

      // this.templateInfo.horizontal_content_list[index].value = value;
    },
    add_button() {
      if (!this.templateInfo.button_list?.length) {
        this.templateInfo.button_list = [];
      }
      this.templateInfo.button_list.push({ text: '', style: '', key: '' });
    },
    del_button(index) {
      this.templateInfo.button_list.splice(index, 1);
    },

    goBack() {
      this.$router.push({
        name: 'workflow-event-list',
        query: {
          statusTab: this.statusTab,
          eventTypes: this.eventTypes,
        },
      });
    },
    submitNoitceDetail() {
      this.$refs.basicForm.validate((basicValid) => {
        this.$refs.templateForm.validate(async (templateValid) => {
          if (!templateValid || !basicValid) {
            return;
          }
          if (!this.templateInfo?.to?.length && !this.templateInfo.to2) {
            this.$message.error('接收人设置至少选填一项');
            return;
          }
          if (this.templateInfo.to2 === 'specify_variable' && !this.templateInfo.variable) {
            this.$message.error('请输入指定变量');
            return;
          }

          const {
            main_title,
            source_switch,
            source,
            horizontal_content_list_switch,
            horizontal_content_list,
            card_action_switch,
            card_action,
            // button_list_switch,
            button_list,
            replace_text,
          } = this.templateInfo;
          const template_card = {
            main_title,
          };
          if (source_switch) {
            const file = await this.$refs.logo.getCosUrl();
            template_card.source = {
              ...source,
              icon_url: file?.[0]?.url ? file?.[0]?.url : '',
            };
          }
          if (horizontal_content_list_switch) {
            template_card.horizontal_content_list = horizontal_content_list;
          }
          if (card_action_switch) {
            template_card.card_action = card_action;
          }
          if (button_list?.length) {
            template_card.button_list = button_list;
          }
          if (replace_text) {
            template_card.replace_text = replace_text;
          }

          const detailData = {
            category: 1, // 1是通知事件， 2是云函数
            status: 1,
            name: this.basicInfo.name,
            event_key: this.basicInfo.event_key,
            remark: this.basicInfo.remark,
            template: {
              notify: {
                editor_type: this.templateInfo.editor_type,
                script: this.templateInfo.script,
                title: this.templateInfo.title,
                content: this.templateInfo.content,
                platform: this.templateInfo.platform,
                to: this.templateInfo.to,
                to2: this.generateTo2,
                to_type: this.generateToType,
                subref: this.templateInfo.subref,
                wxmsg_type: this.templateInfo.wxmsg_type || undefined,
                system_type: this.templateInfo.system_type || undefined,
                btn_msg_body: JSON.stringify({ template_card }),
              },
            },
          };
          if (!this.id) {
            this.createNoticeEvent(detailData);
          } else {
            delete detailData.status;
            this.updateNoticeEvent({
              id: this.id,
              ...detailData,
            });
          }
        });
      });
    },
    createNoticeEvent(data) {
      this.$request({
        url: this.$api.createProcessAction,
        data,
        cb: (resdata) => {
          if (resdata.id) {
            this.$message.success('提交成功');
            this.goBack();
          }
        },
      });
    },
    updateNoticeEvent(data) {
      this.$request({
        url: this.$api.updateProcessAction,
        data,
        cb: (resdata) => {
          if (resdata) {
            this.$message.success('提交成功');
            this.goBack();
          }
        },
      });
    },
    openMetaDiagLog(type) {
      this.insertType = type;
      this.$refs.metaDialog.openDialog();
    },
    insertion(str = '') {
      let selector = '';
      let field = '';
      if (this.insertType === 'title') {
        selector = '.notice-title .el-input__inner';
        field = 'title';
        const dom = document.querySelector(selector);
        this.templateInfo[field] = `${
          this.templateInfo[field].substring(0, dom.selectionStart) +
          str +
          this.templateInfo[field].substring(dom.selectionEnd, dom.textLength)
        }`;
      } else if (this.insertType === 'content' && this.templateInfo.subref !== 'wxmsg') {
        this.templateInfo.content += str;
      } else if (
        this.insertType === 'content' &&
        this.templateInfo.subref === 'wxmsg' &&
        this.templateInfo.wxmsg_type !== 1
      ) {
        this.copytext = str;
        this.$refs.copy.copy();
      } else {
        selector = '.notice-content .el-textarea__inner';
        field = 'content';
        const dom = document.querySelector(selector);
        this.templateInfo[field] = `${
          this.templateInfo[field].substring(0, dom.selectionStart) +
          str +
          this.templateInfo[field].substring(dom.selectionEnd, dom.textLength)
        }`;
      }
    },
    getSystemMessageTypes() {
      this.$request({
        url: this.$api.metaGetObjectByName,
        data: {
          objects: ['message'],
        },
        cb: ({ list }) => {
          if (list.length) {
            const field = list[0].fields.filter(({ name }) => name === 'type');
            this.systemMessageTypeList = field[0].select_one_option.options;
          }
        },
      });
    },
    emailMsgTypeChange() {
      this.templateInfo.content = '';
    },
    openPreview() {
      this.$refs.previewBox.show({
        title: '预览',
        width: '960px',
        top: '30vh',
        confirmText: '返回',
        exitButton: true,
        confirmAction: this.$refs.previewBox.close,
      });
    },
    openHelp() {
      this.$refs.helpBox.show({
        title: '帮助',
        width: '960px',
        top: '30vh',
        confirmText: '返回',
        exitButton: true,
        confirmAction: this.$refs.helpBox.close,
      });
    },
    validateContent() {
      if (this.needPlatform) {
        const platformFlagMap = { 1: 'wx', 2: 'web' };
        const platforms = (this.templateInfo.platform || []).map((item) => platformFlagMap[item]);
        const { content } = this.templateInfo;
        const parser = new DOMParser();
        const doc = parser.parseFromString(content, 'text/html');
        const links = doc.querySelectorAll('a');
        const hrefs = Array.from(links).map(function (link) {
          return link.getAttribute('href');
        });
        if (hrefs.length) {
          for (let i = 0; i < hrefs.length; i++) {
            const href = hrefs[i];
            const regex = /\[\(([a-zA-Z0-9]+)\).*?\]/g;
            let match;
            const plats = [];
            while ((match = regex.exec(href)) !== null) {
              plats.push(match[1]);
            }
            // 如果勾选了，而没有配对应平台的链接，则报错
            if (_.difference(platforms, plats).length) {
              return new Error('请确保为每个选中的终端填写对应的链接。');
            }
            if (_.difference(plats, platforms).length) {
              return new Error('请选择超链接对应的通知终端。');
            }
          }
        }
      }
      return null;
    },
    async handleRequest(file) {
      if (!/.png|.svg|.jpg/gi.test(file.file.name)) {
        this.$message.error('文件格式只支持svg/png/jpg');
        return false;
      }
      const pattern = new RegExp(
        "[%--`~!@#$^&*()=|{}':;',\\[\\]<>/?~！@#￥……&*（）——| {}【】‘；：”“'。，、？]",
      );
      const s = file.file.name;
      let rs = '';
      for (let i = 0; i < s.length; i++) {
        rs = rs + s.substr(i, 1).replace(pattern, '');
      }
      const cosParams = {
        imgCosKey: `${file.file.uid}${rs}`,
        fileObject: file.file,
      };
      try {
        const res = await this.putCosObject(cosParams);
        this.templateInfo.source.icon_url = res.data;
      } catch (err) {
        console.log(err);
        this.$message('上传失败，请稍后再试');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  .button-group {
    display: flex;
    margin-top: 20px;
  }
  ::v-deep .ql-toolbar.ql-snow + .ql-container.ql-snow {
    min-height: 200px;
  }
  .form-input {
    width: 50%;
  }
}
.editor-block {
  display: flex;
  .editor-part {
    flex: 1;
    margin-right: 16px;
    .editor-title {
      margin-bottom: 8px;
    }
    .code-editor {
      border: 1px solid black;
      flex: 1;
    }
  }
}

.preview-box {
  ::v-deep .el-dialog__body {
    padding-left: 20px;
  }
}
.el-icon-delete.del {
  display: flex;
  align-items: center;
  margin-left: 12px;
  justify-content: center;
  width: 40px;
}
::v-deep .button_list_item .el-form-item__label {
  padding-right: 28px;
}
</style>
